'use strict';

var getNodeFromSelector = require('widget/scripts/lib/commons/getNodeFromSelector');

module.exports = function (renderIntoNode) {

    var isSelector = typeof renderIntoNode === 'string',
        isPureDomNode = renderIntoNode instanceof(Node),
        isNotEmptyJQueryCollection = renderIntoNode && !!renderIntoNode.jquery && renderIntoNode.length > 0,
        normalizedNode;

    if (isNotEmptyJQueryCollection) {
        normalizedNode = renderIntoNode.get(0);
    } else if (isPureDomNode) {
        normalizedNode = renderIntoNode;
    } else if (isSelector) {
        normalizedNode = getNodeFromSelector(renderIntoNode);
    }

    if (!normalizedNode) {
        throw new Error('iVis.Widget: expects node to be either a valid: DOM Node, jQuery non-empty collection or a selector');
    }

    return normalizedNode;
};



//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/lib/commons/normalizeRenderIntoNode.js
// module id = 13
// module chunks = 0 1